import { system, LookupStorage } from "portalframework";
import * as ko from "knockout";
import * as $ from "jquery";
import * as _ from "lodash";
import { product_contact, productExtended, productScreenData, ProductSearchCriteria, searchResult } from "organized";
import labels from "app/labels";
import { BaseService } from "./_common/_baseService";
import { AttachmentResultDTO, downloadAttachmentFromBase64 } from "./attachment.service";
import { ResponsiveTableHeader } from "components/_common/responsive-table/DTOs/ResponsiveTableHeader";
import { portalHttpService } from "./_common/httpService";
import { address } from "entitiesE";
class ProductService extends BaseService {
  taskMngmntControllerName: KnockoutObservable<string>;

  constructor() {
    super("Products");
    this.taskMngmntControllerName = ko.observable("Task_Managment");
  }

  public getProductListScreenData = async (): Promise<productScreenData> => {
    const requiredLookups = ["TASK_TYPE", "TASK_STATUS"];
    const lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    const data = ko.toJSON({ requiredLookups: lookupsToFetch });

    const requestResult: productScreenData = await portalHttpService.post<any>(
      `${system.apiURL()}api/${this.controllerName}/ProductListScreenData`,
      data,
    );

    lookupsToFetch.forEach((lookupName) => {
      let list = requestResult.result[lookupName];
      if (list) {
        if (lookupName == "PLACEPERSONS") {
          if (!Array.isArray(list.person)) {
            list["placepersons"] = [list["person"]];
          } else {
            list["placepersons"] = list["person"];
          }
          delete list["person"];
          _.each(list.placepersons, (p) => {
            p.description = p.first_name + " " + p.last_name;
            p.placepersons = p.person_id;
          });
        }

        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });

    return requestResult;
  };

  public searchProducts = async (criteria: ProductSearchCriteria): Promise<searchResult<productExtended[]>> => {
    const data = await portalHttpService.post<any>(
      system.apiURL() + "api/Products/SearchProducts",
      ko.toJSON(criteria),
    );
    let products = _.map(data.result.product, (p) => {
      return new productExtended(p);
    });

    return new searchResult<productExtended[]>({
      count: data.count,
      result: products,
    });
  };

  public getProduct = async (product_id: string): Promise<productExtended> => {
    let requiredLookups = ["CONTR_TYPE", "WTY_COV_TYPE", "C_PRODUCT_CONTACT"];
    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let data1 = ko.toJSON({ product_id: product_id, requiredLookups: lookupsToFetch });
    const data = await portalHttpService.post<any>(system.apiURL() + "api/Products/GetProduct", data1);

    lookupsToFetch.forEach((lookupName) => {
      let list = data.results[lookupName];
      if (list) {
        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });

    let prod: productExtended = null;
    if (data.results && data.results.product && data.results.product.product) {
      prod = new productExtended(data.results.product.product);
    }

    return prod;
  };

  public getNextVisit = async (product_id: string): Promise<string> => {
    let data = ko.toJSON({ product_id: product_id });
    const res = await portalHttpService.post<any>(system.apiURL() + "api/ProductNotes/GetNextVisitNote", data);
    let next_visit = "";
    if (res.product_note && res.product_note.product_note) {
      next_visit = <string>res.product_note.product_note.note;
    }
    return next_visit;
  };

  public updateProduct = async (product: productExtended): Promise<void> => {
    let data = ko.toJSON(product);
    await portalHttpService.post<any>(system.apiURL() + "api/Products/UpdateProduct", data);
  };

  public updateNextVisit = async (product_id: string, note: string): Promise<void> => {
    let data = ko.toJSON({ product_id, note });
    await portalHttpService.post<any>(system.apiURL() + "api/ProductNotes/UpdateNextVisitNote", data);
  };

  public exportFile = async (criteria: ProductSearchCriteria, headers: ResponsiveTableHeader[]) => {
    const labelsResult = headers
      .filter((header) => header.label !== "cc_P_IoT_STATUS")
      .map((header) => header.label)
      .join(",");
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/ExportFile/`);
    myUrlWithParams.searchParams.append("criteria", ko.toJSON(criteria));
    myUrlWithParams.searchParams.append("labelsString", labelsResult);

    const fileResult: AttachmentResultDTO = await portalHttpService.get<any>(myUrlWithParams.href);

    downloadAttachmentFromBase64(fileResult);
  };

  public getTonerDeliveries = (product_id: string) => {
    return portalHttpService.get<any>(`${this.baseApiUrl()}/GetTonerDeliveries/${product_id}`);
  };

  public getPendingAddressChange = (product_id: string) => {
    return portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetPendingAddressChange/${product_id}`);
  };

  public saveAddressChange = async (product_id: string, address: address, address_type: string): Promise<string[]> => {
    const result = await portalHttpService.post<any>(
      `${this.baseApiUrl()}/SaveAddressChange`,
      ko.toJSON({ product_id, address, address_type }),
    );

    return result?.pending_address_types as string[];
  };

  public getProductContacts = async (product_id: string): Promise<product_contact[]> => {
    const data = await portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetProductContacts/${product_id}`);
    return _.map(data, (c) => {
      return new product_contact(c);
    });
  };

  public saveProductContacts = async (product_id: string, data): Promise<void> => {
    await portalHttpService.post<any>(`${this.baseApiUrl()}/SaveProductContacts`, ko.toJSON({ product_id, data }));
  };

  protected setLookupData = (lookupsToFetch: string[], results: any) => {
    _.each(lookupsToFetch, (lookupName) => {
      let list = results[lookupName];
      if (list) {
        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
  };
}
export const productService = new ProductService();
